import React from 'react';

import { INoticesProps } from 'hooks/notices';

import Modal from '..';
import Button from '../../Button';

import * as S from './styles';

const icons = {
  success: (
    <img
      src="/images/icons/check-circle.svg"
      alt="Sucesso"
      className="icon success-icon"
    />
  ),
  errors: (
    <img
      src="/images/icons/x-circle.svg"
      alt="Erro"
      className="icon error-icon"
    />
  ),
  allMessages: (
    <img
      src="/images/icons/alert-circle.svg"
      alt="Alerta"
      className="icon warning-icon"
    />
  ),
  warn: (
    <img
      src="/images/icons/alert-circle.svg"
      alt="Alerta"
      className="icon warning-icon"
    />
  ),
};

interface INoticeModalProps {
  onClose(): void;
  onConfirm(): void;
  notices: INoticesProps;
}

const NoticeModal: React.FC<INoticeModalProps> = ({
  onClose,
  onConfirm,
  notices,
}) => {
  return (
    <Modal onClose={onClose} withScroll={false}>
      <S.Container className="notification-modal-container">
        {icons[notices.type]}

        {/* {notices.type === 'errors' && <h3>Erro</h3>}

        {notices.type === 'warn' && <h3>Alerta</h3>} */}

        <ul>
          {notices.messages?.map((message, index) => (
            <li
              key={index}
              className={`${notices.type}`}
              // dangerouslySetInnerHTML={{ __html: message }}
            >
              {message}
            </li>
          ))}
        </ul>

        {notices.needConfirmation && (
          <div className="group-buttons">
            <Button onClick={onClose} className="button-component-outline">
              Cancelar
            </Button>
            <Button onClick={onConfirm}>Sim</Button>
          </div>
        )}
      </S.Container>
    </Modal>
  );
};

export default NoticeModal;
